import React, { useState, useEffect } from "react";
import DataTable from "../components/DataTable.js";
import { fetchDataFromAPI, saveData, deleteData } from "../components/api.js";
const getRangeInputProps = (col) => {
  if (col.type === "range") {
    return { min: 0, step: 1 }; // Limit range inputs to 0-5 with step of 0.1
  }
  return {}; // Return empty object for non-range types
};
const Materials = () => {
  const [materials, setMaterials] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({});
  const [sortField, setSortField] = useState("created_at");
  const [sortOrder, setSortOrder] = useState("desc");
  const [suppliersOptions, setSuppliersOptions] = useState([]);
  const [productsOptions, setProductsOptions] = useState([]);
  const [totalExpenses, setTotalExpenses] = useState(0);
  const [expenseDate, setExpenseDate] = useState(0);

  // useEffect(() => {
  //   fetchData();
  // }, [filters, sortField, sortOrder]);
  useEffect(() => {
    fetchData();
  }, [filters, sortField, sortOrder, currentPage]);
  const fetchData = async (
    page = 1,
    itemsPerPage = 10,
    // startDate = "",
    // endDate = "",
    filters = {}
  ) => {
    try {
      const token = localStorage.getItem("token");
      const filterParamsObj = {
        page,
        limit: 10,
        ...filters,
        includeDeleted: "false",
      };
      console.log("queryParams 1", filterParamsObj);
      // if (startDate && !isNaN(new Date(startDate).getTime())) {
      //   filterParamsObj.startDate = new Date(startDate).toISOString();
      // }

      // // Validate and format endDate if it is a valid date string
      // if (endDate && !isNaN(new Date(endDate).getTime())) {
      //   filterParamsObj.endDate = new Date(endDate).toISOString();
      // }

      if (sortField) {
        filterParamsObj.sortField = sortField;
      }
      if (sortOrder) {
        filterParamsObj.sortOrder = sortOrder;
      }
      console.log("queryParams 2", filterParamsObj);
      console.log("Filter queryParams:", new URLSearchParams(filterParamsObj));
      const queryString = new URLSearchParams(filterParamsObj).toString();
      console.log("queryString", queryString);
      // Fetch materials
      const { data: materials, pagination } = await fetchDataFromAPI(
        `/api/materials`,
        queryString,
        token
      );

      // Fetch options for suppliers and products
      const { data: suppliers } = await fetchDataFromAPI(
        `/api/suppliers`,
        {},
        token
      );
      const { data: products } = await fetchDataFromAPI(
        `/api/products`,
        {},
        token
      );

      const totalExpenses = Array.isArray(materials)
        ? materials.map((material) => parseFloat(material.total_expenses) || 0)
        : [];
      const formatDate = (dateString) => {
        const date = new Date(dateString);
        // Example: Format to "YYYY-MM-DD"
        return date.toLocaleDateString("en-GB"); // You can change "en-GB" to the desired locale
      };

      const expense_date = materials.map((material) =>
        material.expense_date
          ? new Date(material.expense_date).toISOString()
          : "0000/00/00"
      );
      // Compute expense dates safely
      const expenseDates = Array.isArray(materials)
        ? materials.map((material) =>
            material.expense_date
              ? new Date(material.expense_date).toISOString()
              : "0000-00-00"
          )
        : [];
      setMaterials(materials || []);
      setSuppliersOptions(suppliers || []);
      setProductsOptions(products || []);
      setTotalPages(pagination?.totalPages || 1);
      setTotalExpenses(totalExpenses);
      // setExpenseDate(expense_date);

      // console.log("materials.expense_dates.", materials.expense_dates);
      // console.log("materials.expense_amounts.", materials.expense_amountss);

      // console.log("totalExpenses:", totalExpenses);
      // console.log("expense_date:", expense_date);

      console.log("products:", productsOptions);
      console.log("Materials:", materials);
      console.log("suppliers:", suppliersOptions);
    } catch (err) {
      console.error("Error fetching materials:", err.message);
    }
  };

  const handleAddRow = async () => {
    try {
      const newRow = {
        name: "New Material",
        quantity_remaining: 0,
        suppliers: "", // Default value, can be populated based on user input
        products: "", // Default value, can be populated based on user input
        total_expenses: 0, // Default value
        expense_details: "", // Default value
        expense_names: [], // Default value (empty array)
        expense_dates: [], // Default value (empty array)
      };
      const response = await saveData("/api/materials", newRow, "POST");
      // setMaterials((prevMaterials) => [response, ...prevMaterials]);

      console.log("New row added", response);
      fetchData();
    } catch (err) {
      console.error("Error adding material:", err.message);
    }
  };

  const handleEdit = async (id, updatedData) => {
    console.log(" handleEdit id", id, updatedData);
    try {
      await saveData(`/api/materials/${id}`, updatedData);
      fetchData();
    } catch (err) {
      console.error("Error editing material:", err.message);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteData(`/api/materials/${id}`);
      // setMaterials((prevMaterials) =>
      //   prevMaterials.filter((material) => material.id !== id)
      // );
      fetchData();
    } catch (err) {
      console.error("Error deleting material:", err.message);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchData(newPage);
  };

  const handleSort = (field, order) => {
    setSortField(field);
    setSortOrder(order);
  };

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    fetchData(currentPage, 10);
  };
  const handleDateRangeChange = (start, end) => {
    fetchData(currentPage, 10, start, end); // Fetch with new date range
  };
  const columns = [
    { header: "Material Name", accessor: "name" },
    {
      header: "Supplier",
      accessor: "suppliers",
      type: "list",
      options: suppliersOptions, // Ensure this is populated correctly
    },
    { header: "Quantity Remaining", accessor: "quantity_remaining" },
    {
      header: "Product",
      accessor: "products",
      type: "list",
      options: productsOptions, // Ensure this is populated correctly
    },
    {
      header: "Price",
      accessor: "price",
      type: "range",
    },
    {
      header: "Expense Details",
      accessor: "expenses", // Custom rendering for combined names and dates
      type: "TextDetails",
      // render: (row) => {
      //   const dates = row.materials.expense_dates
      //     ? row.materials.expense_dates.split(",")
      //     : [];
      //   const amounts = row.expense_amounts
      //     ? row.expense_amounts.split(",")
      //     : [];

      //   return dates.map((date, index) => (
      //     <div key={index}>
      //       {date} - {amounts[index] || "N/A"}{" "}
      //       {/* Fallback for missing amounts */}
      //     </div>
      //   ));
      // },
    },
    {
      header: "Total Expenses",
      accessor: "total_expenses",
    },
  ];

  return (
    <DataTable
      title="Materials"
      columns={columns}
      data={materials}
      currentPage={currentPage}
      totalPages={totalPages}
      setData={setMaterials}
      onPageChange={handlePageChange}
      onSort={handleSort}
      sortField={sortField}
      sortOrder={sortOrder}
      filters={filters}
      onFilterChange={handleFilterChange}
      onAddRow={handleAddRow}
      actions={[
        {
          label: "Edit",
          onClick: (row) => {
            const updatedData = { ...row, name: "Updated Material Name" };
            handleEdit(row.id, updatedData);
          },
        },
        {
          label: "Delete",
          onClick: (row) => handleDelete(row.id),
        },
      ]}
      apiEndpoint="/api/materials"
      itemsPerPage={10}
      fetchData={fetchData}
      selectedItems={materials}
      getRangeInputProps={getRangeInputProps}
    />
  );
};

export default Materials;
